<template>
  <div class="main-inner-blk">
    <v-card class="trip-filter-blk" elevation="3">
      <div class="trip-filter">
        <div class="filter-blk">
          <v-text-field v-model="filters.searchquery" placeholder="Search by Trip ID/Crew ID" label="Search by Trip ID/Crew ID" dense hide-details clearable> </v-text-field>
        </div>
        <div class="filter-blk">
          <v-menu v-model="dateRangeModal" :nudge-right="40" :nudge-top="20" :close-on-content-click="false" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="dateRangeText" label="Date Range" readonly dense v-on="on" hide-details> </v-text-field>
            </template>

            <v-date-picker v-model="dateRangeValue" range color="black"></v-date-picker>
          </v-menu>
        </div>
        <div class="filter-blk">
          <v-autocomplete v-model="filters.serviceType" placeholder="Trip Type" label="Trip Type" item-text="name" item-value="id" dense hide-details clearable :items="serviceTypeList">
          </v-autocomplete>
        </div>
        <div class="filter-blk" v-if="verifiedStatus === 10">
          <v-autocomplete v-model="filters.invoiceGenerated" placeholder="Invoice Type" label="Invoice Type" item-text="name" item-value="id" dense hide-details clearable :items="generatedTypes">
          </v-autocomplete>
        </div>
        <div class="filter-blk" v-if="verifiedStatus === 10">
          <v-autocomplete label="Verification Trip Type" v-model="filters.verificationTripType" :items="tripTypes" item-text="name" item-value="id" dense hide-details clearable> </v-autocomplete>
        </div>
        <div class="filter-button">
          <v-btn color="#DD9504" @click="resetFilter" small>Reset</v-btn>
          <v-btn color="green" @click="downloadReport" small v-if="tripList.length > 0">Download</v-btn>
        </div>
      </div>
      <!-- <div class="invoice-action" v-if="verifiedStatus === 10">
        <v-btn small :disabled="selectedList.length === 0" color="#07b5c7" @click="showInvoicePreview">Generate Invoice</v-btn>
      </div> -->
    </v-card>

    <div class="trip-main-blk" :class="{ 'no-trip-blk': tripList.length === 0 }">
      <div v-if="tripList.length > 0">
        <div class="trip-list-content">
          <span class="trip-length-blk">Total Trips: {{ totalCount }}</span>
        </div>
        <TripsView
          :tripList="tripList"
          :listType="'verified'"
          @fetchTrips="fetchTrips"
          class="trip-details"
          :verifiedStatus="verifiedStatus"
          @selectTrips="selectTrips"
          @allSelect="selectAllTrips"
          @disputeResolved="fetchTrips"
          :ownerId="ownerId"
        ></TripsView>
      </div>
      <div class="no-trip-blk" v-if="tripList.length === 0">
        <span>No Trips to Show</span>
      </div>
    </div>
    <div class="pagination">
      <v-pagination v-if="totalCount > 0" v-model="page" :length="Math.ceil(totalCount / pageSize)" :total-visible="6" @input="handlePagination"></v-pagination>
    </div>

    <Loading v-if="loading"></Loading>
  </div>
</template>
<script>
import Loading from "../../common/Loading.vue";
// import Filters from "../../common/filter/Filters.vue";
import moment from "moment";
import axios from "../../../axios/axios-global";
import TripsView from "../verification/TripView.vue";
// import InvocePreview from "../../invoice/InvocePreview.vue";
export default {
  components: { Loading, TripsView },
  props: {
    tab: String,
    verifiedStatus: Number,
    ownerId: String,
  },
  data() {
    return {
      tripList: [],
      loading: false,
      startedTripCount: 0,
      endedTripCount: 0,
      pageCount: 0,
      page: 1,
      pageSize: 20,
      totalCount: 0,
      filters: { searchquery: "", startDate: moment().format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD"), serviceType: -1, invoiceGenerated: 0, verificationTripType: -1 },
      dateRangeModal: false,
      dateRangeValue: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      verifiedStatusList: [
        { id: 0, name: "To be Verified" },
        { id: 2, name: "Re-Verification" },
      ],
      serviceTypeList: [
        { id: 1, name: "PickUp" },
        { id: 2, name: "DropOff" },
        // { id: 3, name: "Rentals" },
      ],
      generatedTypes: [
        { id: 1, name: "Invoice Generated" },
        { id: 2, name: "Invoice Not Generated" },
      ],
      tripTypes: [
        { id: 1, name: "OTP-Trips" },
        { id: 2, name: "Non-OTP Trips" },
      ],
      statusValue: 0,

      selectedList: [],

      invoiceDialog: false,
    };
  },
  methods: {
    handlePagination() {
      this.getFilters({
        start: this.filters.startDate,
        end: this.filters.endDate,
        search: this.filters.searchquery,
        page: this.page,
        limit: this.pageSize,
        tripType: this.filters.serviceType,
        verifiedStatus: [10, 4].includes(this.verifiedStatus) ? this.verifiedStatus : this.statusValue,
        invoiceGenerated: this.filters.invoiceGenerated,
        isExport: false,
      });
    },
    fetchTrips() {
      this.getTripList(this.filters);
    },
    getFilters(data) {
      this.getTripList({
        start: data.start,
        end: data.end,
        searchquery: data.search,
        state: data.state,
        branch: data.branch,
        serviceType: data.tripType,
        page: this.page,
        limit: this.pageSize,
        verifiedStatus: data.verifiedStatus,
        invoiceGenerated: data.invoiceGenerated,
        isExport: data.isExport,
      });
    },
    async getTripList(data) {
      this.loading = true;
      if (!data.isExport) this.tripList = [];
      let branch = localStorage.getItem("selectedBranch");
      if (branch) {
        data.branch = JSON.parse(branch).id;
      }
      data["limit"] = this.pageSize;
      data.start = data.start ? moment(data.start).format("DD-MM-YYYY") : undefined;
      data.end = data.end ? moment(data.end).format("DD-MM-YYYY") : undefined;
      data.verifiedStatus = data.verifiedStatus === 3 ? 0 : data.verifiedStatus;
      data["driverEnded"] = this.filters.verificationTripType;
      let response = await axios.post("/report/disputeList", data);
      this.loading = false;
      if (response && response.status === 200) {
        if (data.isExport) {
          this.exportReport(response.data.report);
        } else {
          this.tripList = response.data.report;
          this.pageCount = response.data.nextpage;
          this.totalCount = response.data.rowCount;
        }
        if (this.verifiedStatus === 10) {
          this.tripList.map((trip) => {
            this.$set(trip, "verified", false);
          });
        }
        console.log(data.isExport, "data.isExport");
      }
    },

    exportReport(tripList) {
      let exportList = [];
      const defaultHeaders = { tripid: "Trip Id", date: "Date", time: "Time", tripType: "Trip type" };
      const maxLength = Math.max(...tripList.map((item) => item.employees.length));
      const numbers = Array.from({ length: maxLength }, (_, index) => index + 1);
      numbers.forEach((number) => {
        defaultHeaders[`emp_${number}_crewId`] = `Employee${number} Crew Id`;
        defaultHeaders[`emp_${number}_name`] = `Employee${number} Name`;
        defaultHeaders[`emp_${number}_gender`] = `Employee${number} Gender`;
      });
      defaultHeaders["start"] = "Pickup Address";
      defaultHeaders["end"] = "Drop Address";
      defaultHeaders["driver"] = "Driver";
      defaultHeaders["vehicleNo"] = "Vehicle No";
      defaultHeaders["slab"] = "Slab";
      defaultHeaders["travelledKms"] = "Total Kms Travelled";

      exportList.push(defaultHeaders);
      tripList.map((trip) => {
        let row = {
          tripid: trip.bigId.toString(),
          date: this.getDate(trip.schedule_date),
          time: this.getTime(trip.schedule_date),
          tripType: trip.tripType,
          start: trip.start || "",
          end: trip.end || "",
          driver: trip.driver.name ? trip.driver.name : "",
          vehicleNo: trip.vehicleNo,
          slab: trip.package,
          travelledKms: trip.driverfare.km ? `${trip.driverfare.km}KM` : 0,
        };
        numbers.forEach((number) => {
          row[`emp_${number}_crewId`] = trip.employees[number - 1] ? trip.employees[number - 1].crewid : "";
          row[`emp_${number}_name`] = trip.employees[number - 1] ? trip.employees[number - 1].name : "";
          row[`emp_${number}_gender`] = trip.employees[number - 1] ? trip.employees[number - 1].gender : "";
        });
        exportList.push(row);
      });

      this.$VueExcel.methods.downloadExcelSheet(exportList, "Trip Report", { skipHeader: true });
    },
    resetFilter() {
      this.filters = { searchquery: "", startDate: moment().format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD"), invoiceGenerated: 0 };
      this.dateRangeModal = false;
      this.statusValue = 0;
      this.dateRangeValue = [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")];
      this.page = 1;
    },
    selectTrips(data) {
      if (data.status) {
        this.selectedList.push(data.trip.id);
      } else {
        this.selectedList.splice(this.selectedList.indexOf(data.trip.id), 1);
      }
    },
    selectAllTrips(trips) {
      this.selectedList = trips;
    },
    showInvoicePreview() {
      this.invoiceDialog = true;
    },

    async downloadReport() {
      this.getTripList({
        start: this.filters.startDate,
        end: this.filters.endDate,
        searchquery: this.filters.searchquery,
        page: this.page,
        limit: this.pageSize,
        serviceType: this.filters.serviceType,
        verifiedStatus: [10, 4].includes(this.verifiedStatus) ? this.verifiedStatus : this.statusValue,
        invoiceGenerated: this.filters.invoiceGenerated,
        isExport: true,
      });
    },

    getDate(data) {
      return data ? moment(data).format("DD-MM-YYYY") : "-";
    },
    getTime(data) {
      return data ? moment(data).format("HH:mm") : "-";
    },

    onFilterChange() {
      this.tripList = [];
      this.page = 1;
      if (this.filters.serviceType === null) this.filters.serviceType = -1;
      this.getFilters({
        start: this.filters.startDate,
        end: this.filters.endDate,
        search: this.filters.searchquery,
        page: this.page,
        limit: this.pageSize,
        tripType: this.filters.serviceType,
        verifiedStatus: [10, 4].includes(this.verifiedStatus) ? this.verifiedStatus : this.statusValue,
        invoiceGenerated: this.filters.invoiceGenerated,
        isExport: false,
      });
    },
    // disputeResolved() {
    //   this.getFilters({
    //     start: this.filters.startDate,
    //     end: this.filters.endDate,
    //     search: this.filters.searchquery,
    //     page: this.page,
    //     limit: this.pageSize,
    //     tripType: this.filters.serviceType === null ? -1 : this.filters.serviceType,
    //   });
    // },
  },
  mounted() {
    this.getFilters({
      start: this.filters.startDate,
      end: this.filters.endDate,
      search: this.filters.searchquery,
      page: this.page,
      limit: this.pageSize,
      tripType: this.filters.serviceType,
      verifiedStatus: [10, 4].includes(this.verifiedStatus) ? this.verifiedStatus : this.statusValue,
      invoiceGenerated: this.filters.invoiceGenerated,
      isExport: false,
    });
  },
  watch: {
    tab() {
      this.resetFilter();
      //    if (this.tab === "tab-verified-list") {
      this.getFilters({
        start: this.filters.startDate,
        end: this.filters.endDate,
        search: this.filters.searchquery,
        page: this.page,
        limit: this.pageSize,
        // tripType: this.filters.serviceType,
        tripType: this.filters.serviceType === null ? -1 : this.filters.serviceType,
        verifiedStatus: [10, 4].includes(this.verifiedStatus) ? this.verifiedStatus : this.statusValue,
        invoiceGenerated: this.filters.invoiceGenerated,
        isExport: false,
      });
      //    }
    },

    "filters.searchquery": "onFilterChange",
    "filters.serviceType": "onFilterChange",
    "filters.invoiceGenerated": "onFilterChange",
    "filters.verificationTripType": "onFilterChange",
    // filters: {
    //   handler() {
    //   },
    //   deep: true,
    // },
    statusValue() {
      this.tripList = [];
      this.page = 1;
      this.getFilters({
        start: this.filters.startDate,
        end: this.filters.endDate,
        search: this.filters.searchquery,
        tripType: this.filters.serviceType,
        page: this.page,
        limit: this.pageSize,
        verifiedStatus: [10, 4].includes(this.verifiedStatus) ? this.verifiedStatus : this.statusValue,
        invoiceGenerated: this.filters.invoiceGenerated,
        isExport: false,
      });
    },
    dateRangeValue() {
      if (this.dateRangeValue[0]) {
        if (this.dateRangeValue[1]) {
          if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
            this.filters.startDate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
            this.filters.endDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
          } else {
            this.filters.startDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
            this.filters.endDate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
          }
          this.dateRangeModal = false;
           this.onFilterChange();
        } else {
          this.filters.startDate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
          this.filters.endDate = moment().format("YYYY-MM-DD");
        }
      }
    },
  },
  computed: {
    dateRangeText() {
      let start = "";
      let end = "";
      if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
        start = moment(this.dateRangeValue[1]).format("MMM DD");
        end = moment(this.dateRangeValue[0]).format("MMM DD");
      } else {
        start = moment(this.dateRangeValue[0]).format("MMM DD");
        end = moment(this.dateRangeValue[1]).format("MMM DD");
      }
      return `${start} ~ ${end}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.trip-filter {
  display: flex;
  align-items: center;
  width: 100%;
}
.filter-blk {
  width: 300px;
  margin-right: 10px;
}
.filter-button {
  display: flex;
  align-items: center;
  gap: 10px;
}
.invoice-action {
  .v-btn {
    color: white;
    font-weight: bold;
  }
}
::v-deep .v-text-field {
  font-size: 13px;
}

::v-deep .v-label {
  font-size: 13px !important;
}

::v-deep .v-list-item__title {
  font-size: 0.7125rem !important;
}
</style>
